// extracted by mini-css-extract-plugin
module.exports = {"container":"LinksGrid_container__h9OtR","title":"LinksGrid_title__3dB1h","button":"LinksGrid_button__IlftG","grid":"LinksGrid_grid___h7d8"};